import type { TableView } from 'owa-mail-list-store';
import { resetMessageAdListSelection } from 'owa-mail-messagead-list-store';
import { resetSelectionOnTable } from 'owa-mail-actions/lib/mailListSelectionActions';
import tableExitVirtualSelectAllMode from './mutators/tableExitVirtualSelectAllMode';

export default function resetSelectionInternal(tableView: TableView): void {
    if (!tableView) {
        throw new Error('resetSelection should not be called on null or undefined table.');
    }

    resetSelectionOnTable(tableView);
    tableExitVirtualSelectAllMode(tableView);

    // Reset the message Ad list selection which potentially occupy the right pane
    resetMessageAdListSelection();
}
